export const NOTIFICATION_TYPE = {
  ERROR: 0,
  SUCCESS: 1,
  SET_NOTIFICATION: 'SET_NOTIFICATION',
};
